import { render, staticRenderFns } from "./specialist-policing-areas.vue?vue&type=template&id=994e7cc0&scoped=true&"
import script from "./specialist-policing-areas.vue?vue&type=script&lang=js&"
export * from "./specialist-policing-areas.vue?vue&type=script&lang=js&"
import style0 from "./specialist-policing-areas.vue?vue&type=style&index=0&id=994e7cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994e7cc0",
  null
  
)

export default component.exports